export enum Permission {
    MANAGE_MEMBER_CREATE = 1,
    MANAGE_MEMBER_VIEW = 2,
    MANAGE_MEMBER_EDIT = 3,
    MANAGE_MEMBER_DELETE = 4,

    MANAGE_ROLE_CREATE = 5,
    MANAGE_ROLE_VIEW = 6,
    MANAGE_ROLE_EDIT = 7,
    MANAGE_ROLE_DELETE = 8,

    MANAGE_STORE_CREATE = 9,
    MANAGE_STORE_VIEW = 10,
    MANAGE_STORE_EDIT = 11,
    MANAGE_STORE_DELETE = 12,

    MANAGE_CATALOGS_CREATE = 13,
    MANAGE_CATALOGS_VIEW = 14,
    MANAGE_CATALOGS_EDIT = 15,
    MANAGE_CATALOGS_DELETE = 16,

    MANAGE_PRODUCT_GLOBAL_CREATE = 18,
    MANAGE_PRODUCT_GLOBAL_EDIT = 19,
    MANAGE_PRODUCT_GLOBAL_ACTIVATE = 20,
    MANAGE_PRODUCT_GLOBAL_VIEW = 21,

    MANAGE_PRODUCT_CATEGORY_CREATE = 22,
    MANAGE_PRODUCT_CATEGORY_ACTIVATE = 23,
    MANAGE_PRODUCT_CATEGORY_EDIT = 24,
    MANAGE_PRODUCT_CATEGORY_VIEW = 25,

    MANAGE_PRODUCT_Purchase_Flow_VIEW = 26,
    MANAGE_PRODUCT_Purchase_Flow_EDIT = 27,

    MANAGE_PRODUCT_ATTRIBUTE_CREATE = 28,
    MANAGE_PRODUCT_ATTRIBUTE_ACTIVATE = 29,
    MANAGE_PRODUCT_ATTRIBUTE_VIEW = 30,
    MANAGE_PRODUCT_ATTRIBUTE_EDIT = 31,

    MANAGE_PRODUCT_ASSOCIATION_CREATE = 32,
    MANAGE_PRODUCT_ASSOCIATION_ACTIVATE = 33,
    MANAGE_PRODUCT_ASSOCIATION_VIEW = 34,
    MANAGE_PRODUCT_ASSOCIATION_EDIT = 35,

    MANAGE_PRODUCT_TAG_CREATE = 36,
    MANAGE_PRODUCT_TAG_ACTIVATE = 37,
    MANAGE_PRODUCT_TAG_VIEW = 38,
    MANAGE_PRODUCT_TAG_EDIT = 39,

    MANAGE_PRODUCT_OPTION_CREATE = 73,
    MANAGE_PRODUCT_OPTION_ACTIVATE = 74,
    MANAGE_PRODUCT_OPTION_VIEW = 75,
    MANAGE_PRODUCT_OPTION_EDIT = 76,

    MANAGE_BUSINESS_ENTITY_CREATE = 49,
    MANAGE_BUSINESS_ENTITY_VIEW = 50,
    MANAGE_BUSINESS_ENTITY_EDIT = 51,
    MANAGE_BUSINESS_ENTITY_DELETE = 52,

    MANAGE_COUNTRY_CREATE = 53,
    MANAGE_COUNTRY_VIEW = 54,
    MANAGE_COUNTRY_EDIT = 55,
    MANAGE_COUNTRY_DELETE = 56,

    MANAGE_CURRENCY_CREATE = 57,
    MANAGE_CURRENCY_VIEW = 58,
    MANAGE_CURRENCY_EDIT = 59,
    MANAGE_CURRENCY_DELETE = 60,

    MANAGE_CULTURE_CREATE = 61,
    MANAGE_CULTURE_VIEW = 62,
    MANAGE_CULTURE_EDIT = 63,
    MANAGE_CULTURE_DELETE = 64,

    MANAGE_LANGUAGE_CREATE = 65,
    MANAGE_LANGUAGE_VIEW = 66,
    MANAGE_LANGUAGE_EDIT = 67,
    MANAGE_LANGUAGE_DELETE = 68,

    MANAGE_STORE_USER_ASSIGN = 69,
    MANAGE_STORE_USER_VIEW = 70,
    MANAGE_STORE_USER_EDIT = 71,
    MANAGE_STORE_USER_DELETE = 72,

    MANAGE_PRODUCT_CUSTOM_CATALOG_CREATE = 77,
    MANAGE_PRODUCT_CUSTOM_CATALOG_ACTIVATE = 78,
    MANAGE_PRODUCT_CUSTOM_CATALOG_VIEW = 79,
    MANAGE_PRODUCT_CUSTOM_CATALOG_EDIT = 80,

    MANAGE_PRODUCT_REVIEW_APPROVE = 85,
    MANAGE_PRODUCT_REVIEW_DELETE = 86,
    MANAGE_PRODUCT_REVIEW_VIEW = 87,

    MANAGE_PRODUCT_STORE_CREATE = 81,
    MANAGE_PRODUCT_STORE_DEACTIVATE = 82,
    MANAGE_PRODUCT_STORE_VIEW = 83,
    MANAGE_PRODUCT_STORE_EDIT = 84,

    MANAGE_CONTENT_CREATE = 88,
    MANAGE_CONTENT_EDIT = 89,
    MANAGE_CONTENT_TRANSLATE = 90,
    MANAGE_CONTENT_APPROVE = 91,
    MANAGE_CONTENT_PUBLISH = 92,

    MANAGE_PAYMENT_METHOD_CREATE = 93,
    MANAGE_PAYMENT_METHOD_EDIT = 94,
    MANAGE_PAYMENT_METHOD_DELETE = 95,
    MANAGE_PAYMENT_METHOD_VIEW = 99,

    MANAGE_PAYMENT_PROCESSOR_CREATE = 96,
    MANAGE_PAYMENT_PROCESSOR_EDIT = 97,
    MANAGE_PAYMENT_PROCESSOR_DELETE = 98,
    MANAGE_PAYMENT_PROCESSOR_VIEW = 100,

    MANAGE_STORE_ACTIVATE = 116,
    MANAGE_LANGUAGE_ACTIVATE = 117,
    MANAGE_COUNTRY_ACTIVATE = 118,
    MANAGE_CURRENCY_ACTIVATE = 119,
    MANAGE_BUSINESS_ENTITY_ACTIVATE = 120,

    STORE_PAYMENT_METHODS_VIEW = 101,
    STORE_PAYMENT_METHODS_EDIT = 102,

    STORE_PAYMENT_PROCESSORS_VIEW = 103,
    STORE_PAYMENT_PROCESSORS_EDIT = 104,

    // Customer service Permissions.
    RESET_PASSWORD = 122,
    IMPERSONATION = 123,
    FBO_PROFILE_VIEW = 124,
    FBO_ORDER_HISTORY_VIEW = 125,
    FBO_AUTOSHIP_DETAILS_VIEW = 126,
    FBO_PAYMENT_METHODS_VIEW = 127,
    FBO_DOWNLINE_VIEW = 128,
    FBO_REPORTS_VIEW = 129,
    FLP360_IMPERSONATION = 277,
    FLP360_RESET_PASSWORD = 288,


  // Customer service Permissions--NEWLEY ADDED.

  Unlock_Account =207,
  FBO_LEVEL_HISTORY=208,
  FBO_CHANGE_SPONSER=209,
  FBO_HOME_COUNTRY=210,
  FBO_MEMBER_TYPE=211,
  FBO_UPDATE_PHONE_NUMBER=212,
  FBO_OVERRIDE_MAXIMUM_CC_FBO=213,
  FBO_CHANGE_GOVERNMENT_ID=214,

    //  Retail permission
    CUSTOMER_DETAILS_VIEW = 130,
    CUSTOMER_ORDER_HISTORY_VIEW = 131,

    SEND_EMAILS_ALLOW = 132,
    EXPORT_FILE_ALLOW = 133,

    MANAGE_TICKETS_CREATE = 134,
   // MANAGE_TICKETS_ASSIGN = 135,
    MANAGE_TICKETS_VIEW = 136,
    MANAGE_TICKETS_ADD_NOTE_ATTACHMENT = 137,

    KNOWLEDGEBASE_ALLOW = 138,

    MANAGE_DEPARTMENT_TICKETS_ASSIGN = 135,
    MANAGE_DEPARTMENT_TICKETS_EDIT = 166,
    MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN = 167,
    MANAGE_DEPARTMENT_TICKETS_REASSIGN = 168,
    MANAGE_DEPARTMENT_TICKETS_CLOSE = 169,
    MANAGE_DEPARTMENT_TICKETS_RE_OPEN = 170,
    MANAGE_DEPARTMENT_USERS_VIEW = 171,
    MANAGE_DEPARTMENT_USERS_EDIT = 172,
    MANAGE_DEPARTMENT_USERS_ASSIGN = 173,

    MANAGE_DEPARTMENT_CREATE= 174,
    MANAGE_DEPARTMENT_VIEW = 175,
    MANAGE_DEPARTMENT_EDIT = 176,
    MANAGE_DEPARTMENT_DEACTIVATE = 177,
    MANAGE_DEPARTMENT_ACTIVATE = 178,

    MANAGE_SHIPPING_CREATE= 186,
    MANAGE_SHIPPING_VIEW = 187,
    MANAGE_SHIPPING_EDIT = 188,
    MANAGE_SHIPPING_DELETE = 189,

    REGULAR_ORDER_CREATE = 220,
    REGULAR_ORDER_VIEW = 224,
    REGULAR_ORDER_MANAGE = 222,
    REGULAR_ORDER_CANCEL =223,
    REGULAR_ORDER_REFUND = 221,

    POS_ORDER_CREATE = 225,
    POS_ORDER_VIEW = 226,
    POS_ORDER_REFUND = 227,
    POS_ORDER_MANAGE = 228,
    POS_ORDER_CANCEL = 229,

    REPLACEMENT_ORDER_CREATE = 230,
    REPLACEMENT_ORDER_VIEW = 231,
    REPLACEMENT_ORDER_REFUND = 232,
    REPLACEMENT_ORDER_MANAGE = 233,
    REPLACEMENT_ORDER_CANCEL = 234,
    REPLACEMENT_ORDER_STATUS_UPDATE=387,
    
    MEMBER_NOTES_CREATE = 235,
    MEMBER_NOTES_VIEW = 236,
    
    MEMBER_ATTACHMENTS_CREATE = 237,
    MEMBER_ATTACHMENTS_VIEW = 238,
    MEMBER_ATTACHMENTS_DELETE = 239,
    MEMBER_ATTACHMENTS_DOWNLOAD = 240,

    MANAGE_FBO_BUSINESS_ENTITY_CREATE = 241,
    MANAGE_FBO_BUSINESS_ENTITY_VIEW = 242,
    MANAGE_FBO_BUSINESS_ENTITY_EDIT = 243,
    MEMBER_STATUS_VIEW = 248,
    MEMBER_STATUS_EDIT = 249,
    MANAGE_MEMBER_PREFERENCES = 294,

    MANAGE_FBO_DOB_CREATE = 261,

    MEMBER_ACTIVITY_LOG_VIEW = 260,

    ORDER_BACKDATE = 264,
    MANAGE_ACCOUNT_NOTIFICATION = 274,
    UPDATE_FULL_NAME_ALLOW = 216,
    UPDATE_EMAIL_ADDRESS = 218,
    
    CHANGE_OPERATING_COMPANY_ALLOW=275,
    CHANGE_REGISTERED_ADDRESS_ALLOW=276,
    MANAGE_RETAIL_AND_GUEST = 278,
    RELEASE_MO = 279,
    RELEASE_WIRE_TRANSFER = 385,

    CREATE_SHOPPING_BAG = 280,
    VIEW_SHOPPING_BAG = 281,
    MANAGE_SHOPPING_BAG = 282,
    MANAGE_RETAIL = 289,
    MANAGE_FPC = 297,
    MANAGE_FBO = 302,
    BONUS_REISSUE_TICKETS_CREATE = 290,
    RELEASE_BF = 296,

    CREATE_JAPAN_DATA = 303,
    VIEW_JAPAN_DATA = 304,
    EDIT_JAPAN_DATA = 305,

    GENERAL_SPONSOR_CHANGE = 317,
    MANAGE_COMPOSE_EMAIL = 316,
    
    FBO_VIEW_GOVERNMENT_ID=320,
    FBO_MANAGE_GOVERNMENT_ID = 321,

 // PaybyAccount Check Info
     MANAGE_PERSONAL_CHECK=340,

     MANAGE_RECOGNITION_DATA_UPLOAD = 346,
     FBO_BONUS_INFO_VIEW = 350,
     FBO_BONUS_INFO_DELETE = 351,
     FBO_BONUS_INFO_MANAGE = 352,

    STORE_BUSINESS_ENTITY_VIEW = 353,
    STORE_BUSINESS_ENTITY_MANAGE = 354,

    // REPORTS TAB PERMISSION
    MANAGE_REPORTS = 359,
    RUN_REPORTS = 364,
    INVOICE_PRINTING = 365,

    SINGLE_AND_DIRECT_DEBIT_VIEW = 361,
    SINGLE_AND_DIRECT_DEBIT_MANAGE = 362,

    MANAGE_EMAIL_CONFIGURATION = 366,
    OVERRIDE_MINIMUM_LIMIT=368,
    ORDER_STATUS_UPDATE=369,
    RELEASE_COD = 367,
    MANAGE_RETAIL_SUBSCRIPTION = 370,

    //BONUS TAB PERMISSION
    BOUNS_MANAGEMENT_CONSOLE = 374,

    //Manage Anonymous retail Orders
    MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE=375,
    MANAGE_ANONYMOUS_RETAIL_ORDER_EDIT=376,
    MANAGE_ANONYMOUS_RETAIL_ORDER_DELETE=377,
    MANAGE_ANONYMOUS_RETAIL_ORDER_APPROVE=378,

    //Account Restriction
    ACCOUNT_RESTRICTED_VIEW = 379,
    ACCOUNT_RESTRICTED_MANAGE = 381,
    COMMISSION_ACTIVITIES = 386,

    //Bonded Warehouse Project
    Bonded_Warehouse_Project_VIEW = 391,
    Bonded_Warehouse_Project_MANAGE = 392,
    ALTERNATIVE_LANGUAGE_SEARCH_PERMISSION = 398
}



// WEBPACK FOOTER //
// ./src/app/common/enums/permission.enum.ts